import { render, staticRenderFns } from "./DataSourcesSettingsList.vue?vue&type=template&id=9ed1b7a6&scoped=true&"
import script from "./DataSourcesSettingsList.vue?vue&type=script&lang=js&"
export * from "./DataSourcesSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./DataSourcesSettingsList.vue?vue&type=style&index=0&id=9ed1b7a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed1b7a6",
  null
  
)

export default component.exports